import type { EditorPreviewCardEntry } from '@source-components-react/types';
import { ComponentIdentifiers } from '@source-components-react/component-identifiers';

export const previewCardEntry: EditorPreviewCardEntry = {
  id: ComponentIdentifiers.rEmbed,
  // One frame inside another, which is what an embed is. A film clapper or a
  // map pin would each name one provider at the expense of the other three,
  // and the picture emoji is already the Image card.
  icon: '⧉',
  label: 'Embed',
};
